import React, { HTMLAttributes } from 'react';

const Bars = ({ className }: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <rect x="4" y="7" width="16" height="2" rx="1" fill="#000" />
    <rect x="4" y="15" width="16" height="2" rx="1" fill="#000" />
  </svg>
);
export default Bars;
